export default function calculateEffectiveFate({ currentFate, currentNex }: { currentFate?: number, currentNex?: number }) {
  return Number(currentFate ?? 0) + Number(currentNex ?? 0);
}